import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { HotKeys } from 'react-hotkeys';

import Button from '../../../../../../../../../components/global/Button';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../constants/image-size-codes';
import SlideThumbnailControls from '../../../../../AlbumSlideshow/AlbumSlideshowDesignerView/components/SecondaryPhotosView/components/SlidesStep/components/SlideThumbnail/components/SlideThumbnailControls';
import { getThumbBySize } from '../../../../../../../../../util/photo';

const propTypes = {
  video: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isSeen: PropTypes.bool,
  elapsedPercent: PropTypes.number,
  className: PropTypes.string,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
  onDelete: PropTypes.func,
};

const VideoSlideshowThumbnail = ({
  video,
  onClick,
  isActive,
  isSeen,
  elapsedPercent,
  className,
  onMoveUp,
  onMoveDown,
  onDelete,
  style,
}) => {
  const classes = classNames({
    'secondary-photos-view-slides-step-slide-thumbnail': true,
    'is-active': isActive,
    [className]: !!className,
  });

  const thumbnail = getThumbBySize(
    video.thumbnails,
    IMAGE_SIZE_CODE.SMALL2X,
    true,
  );

  return (
    <HotKeys
      keyMap={{
        onMoveDown: onMoveDown ? 'right' : undefined,
        onMoveUp: onMoveUp ? 'left' : undefined,
      }}
      handlers={{ onMoveDown, onMoveUp }}
      style={style}
    >
      {isActive && (
        <SlideThumbnailControls
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onDelete={onDelete}
        />
      )}
      <Button btnStyle="reset" className={classes} onClick={onClick}>
        {(isSeen || isActive) && (
          <div
            className="slide-thumbnail-seen-overlay"
            style={{
              width: isSeen ? '100%' : `${100 * (elapsedPercent ?? 0)}%`,
            }}
          />
        )}
        <img src={thumbnail?.url ?? ''} alt="Slideshow Thumbnail" />
      </Button>
    </HotKeys>
  );
};

VideoSlideshowThumbnail.propTypes = propTypes;

export default VideoSlideshowThumbnail;
